import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  PAYER_ADDRESS_FIELDS
} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages from '..';

type Field = {
  key: string;
  conditionalCountryArray?: string[];
};

type Card = {
  key: string;
  hideSameAs?: boolean;
  fields?: Field[];
};

type PageTemplate = {
  route: string;
  cards: Card[];
};

describe('Payer Page Template', () => {
  it('exports pages array with one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const payerPage = (pages as PageTemplate[]).find(p => p.route === PAGE_ROUTES.financial);

  it('has correct route', () => {
    expect(payerPage).toBeDefined();
    expect(payerPage?.route).toBe(PAGE_ROUTES.financial);
  });

  it('contains expected cards', () => {
    expect(Array.isArray(payerPage?.cards)).toBe(true);
    expect(payerPage?.cards.map(c => c.key)).toEqual([
      CARD_CATEGORIES.payer,
      CARD_CATEGORIES.financialAttachmentCard,
      CARD_CATEGORIES.additionalAttachmentCard,
      CARD_CATEGORIES.privacyPolicy
    ]);
  });

  describe('Payer Address Card', () => {
    const payerCard = payerPage?.cards.find(c => c.key === CARD_CATEGORIES.payer);

    it('has hideSameAs enabled', () => {
      expect(payerCard).toBeDefined();
      expect(payerCard?.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(payerCard?.fields?.map(f => f.key)).toEqual([
        PAYER_ADDRESS_FIELDS.address,
        PAYER_ADDRESS_FIELDS.taxNumber1,
        PAYER_ADDRESS_FIELDS.taxNumber2,
        PAYER_ADDRESS_FIELDS.telephone1,
        PAYER_ADDRESS_FIELDS.telephone2
      ]);
    });

    it('has conditionalCountryArray for taxNumber1', () => {
      const taxField = payerCard?.fields?.find(f => f.key === PAYER_ADDRESS_FIELDS.taxNumber1);
      expect(Array.isArray(taxField?.conditionalCountryArray)).toBe(true);
      expect(taxField?.conditionalCountryArray?.length).toBeGreaterThan(0);
    });
  });

  describe('Attachment & Privacy Cards', () => {
    it('contains financialAttachmentCard', () => {
      const attachmentCard = payerPage?.cards.find(c => c.key === CARD_CATEGORIES.financialAttachmentCard);
      expect(attachmentCard).toBeDefined();
      expect(attachmentCard?.fields?.[0].key).toBe(ATTACHMENT_FIELDS.financialCardAttachment);
    });

    it('contains additionalAttachmentCard', () => {
      const additionalCard = payerPage?.cards.find(c => c.key === CARD_CATEGORIES.additionalAttachmentCard);
      expect(additionalCard).toBeDefined();
      expect(additionalCard?.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = payerPage?.cards.find(c => c.key === CARD_CATEGORIES.privacyPolicy);
      expect(privacyCard).toBeDefined();
      expect(privacyCard?.fields).toBeUndefined();
    });
  });
});